module.exports = require('./helpers/bundle-url').getBundleURL('kAx7u') + "logo-dark.eefe0b7f.svg";